module.exports = __webpack_public_path__ + "assets/img/icon-powerplant-white.svg";